<template>
  <div class="mylayout">
    <el-form class="myform" :model="form" ref="ruleFormRef" label-position="right" label-width="64px">
      <p style="margin: 0px 0px 10px 0px;">全球</p>
      <!--##################################################################-->
      <el-form-item prop="timetype" style="margin-left: -54px">
        <el-radio-group v-model="form.timetype">
          <el-radio label="y-m-d" border style="margin-left: 8px; padding: 5px 15px; 
                    border-width: 1.5px;">Y-M-D</el-radio>
          <el-radio label="y-doy" border style="margin-left: 10px; padding: 5px 15px; 
                    border-width: 1.5px;">Y-DOY</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="Y-M-D" prop="ymd">
        <el-date-picker v-model="form.ymd" type="date" :disabled="form.timetype == 'y-m-d' ? false : true"
                        editable  placeholder="2020-01-01" :disabled-date="disabledDate" default-value="2020-01-01"></el-date-picker> 
     </el-form-item>

      <el-form-item label="Y-DOY" prop="year">
        <el-input-number v-model="form.year" :disabled="form.timetype == 'y-doy' ? false : true" 
                         :min="2003" :max="2022" :step="1" step-strictly placeholder="2020" @change="checkyear" />
      </el-form-item>

      <el-form-item label="" prop="doy">
        <el-input-number v-model="form.doy"  :disabled="form.timetype == 'y-doy' ? false : true" 
                         :min="1" :max="form.max_day" :step="1" step-strictly placeholder="1" @change="checkdoy" />
      </el-form-item>
      <!--##################################################################-->
      <el-form-item prop="hourtype" style="margin-left: -54px">
        <el-radio-group v-model="form.hourtype">
          <el-radio label="ut" border style="margin-left: -2px;  padding: 3px 32px; 
                    border-width: 1.5px;">UT</el-radio>
          <el-radio label="lt" border style="margin-left: 10px;  padding: 3px 32px; 
                    border-width: 1.5px;">LT</el-radio>
        </el-radio-group>
      </el-form-item>
      <!--##################################################################-->
      <el-form-item label="Hour" prop="hour" style="margin-left: 0px;">
        <el-input-number v-model="form.hour" :min="0" :max="23" :step="1" step-strictly />
      </el-form-item>
      <!--##################################################################-->
      <el-button @click="onSubmit" style="margin-left: 0px;">Submit</el-button>
      <el-button @click="reset"    style="margin-left: 12px;">Reset</el-button>
      <!--##################################################################-->
    </el-form>
    <!--##################################################################-->
    <div class="mycharts" id="ECharts_Globe"></div>
    <!--##################################################################-->
  </div>
</template>




<script setup>
import * as echarts from 'echarts';
import { ref, onMounted, toRaw } from 'vue'
import axios from '../util/require'

// -------------------------------------------------------------------------- //
// 表单数据
const form = ref({
  timetype: 'y-m-d',
  ymd: new Date("January 01, 2020 00:00:00"),
  year: 2020,
  doy: 1,
  max_day: 365,
  hourtype: 'ut',
  hour: 0,
})
const disabledDate = (time) => {
  return (time.getTime() < new Date("January 01, 2003 00:00:00")) || (time.getTime() > new Date("November 26, 2022 00:00:00"))
}

// 重置表单变量
const ruleFormRef = ref()

// OPTION
const xData = [];
for (let value = -180; value <= 180; value += 5) {
  xData.push(value);
}

const yData = [];
for (let value = 87.5; value >= -87.5; value += -2.5) {
  yData.push(value);
}

let tec = ref([]);
for (let i = 0; i < 73; i++) {
  for (let j = 0; j < 71; j++) {
    tec.value.push([i, j, 0]);
  }
}

let option = ref({
  xAxis: {
    name: 'Longitude',
    nameLocation: 'middle',
    nameGap: 30,
    type: 'category',
    data: xData,
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    axisLabel: {
      fontSize: 16,
      fontFamily: 'Times New Roman',
      interval: (index, value) => {
        if (value % 60 == 0) {
          return true
        }
        else {
          return false
        }
      },
    },
  },
  yAxis: {
    name: 'Latitude',
    nameLocation: 'middle',
    nameGap: 35,
    type: 'category',
    data: yData,
    inverse: true,
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    axisLabel: {
      fontSize: 16,
      fontFamily: 'Times New Roman',
      interval: (index, value) => {
        if (value % 30 == 0) {
          return true
        }
        else {
          return false
        }
      },
    },
  },
  axisPointer: {
    show: true,
    type: 'line',
    snap: true,
    lineStyle: {
      type: 'dashed',
      color: 'purple',
    }
  },
  textStyle: {
    fontSize: 16,
    fontFamily: 'Times New Roman'
  },
  toolbox: {
    show: true,
    orient: 'horizontal',
    left: 'right',
    top: 'middle',
    feature: {
      saveAsImage: { show: true }
    }
  },
  visualMap: {
    type: 'continuous',
    min: 0,
    max: 1,
    range: null,
    calculable: true,
    realtime: false,
    precision: 1,
    itemWidth: 20,
    itemHeight: 200,
    align: 'left',
    text: ['High', 'Low'],
    textGap: 15,
    hoverLink: true,
    inRange: {
      color: [
        '#313695',
        '#4575b4',
        '#74add1',
        '#abd9e9',
        '#e0f3f8',
        '#ffffbf',
        '#fee090',
        '#fdae61',
        '#f46d43',
        '#d73027',
        '#a50026'
      ]
    },
    left: 'center',
    top: 'top',
    orient: 'horizontal',
    padding: [0, 0, 0, 0],
  },
  series: [
    {
      data: tec,
      type: 'heatmap',
      progressive: 500,
      animation: false,
    }
  ],
});


// -------------------------------------------------------------------------- //
// 检查时间
function checkyear() {
  if ((form.value['year'] % 4 == 0 && form.value['year'] % 100 != 0) || (form.value['year'] % 400 == 0)) {
    form.value['max_day'] = 366;
  } else {
    form.value['max_day'] = 365;
    if (form.value['doy'] > 365) {
      form.value['doy'] = 365
    }
  }
  if (form.value['year'] == 2022) {
    form.value['max_day'] = 330;
    if (form.value['doy'] > 330) {
      form.value['doy'] = 330
    }
  }
}

function checkdoy() {
  if (form.value['doy'] > form.value['max_doy']) {
    form.value['doy'] = form.value['max_doy']
  }
}
// 提交表单
function onSubmit() {
  let info = JSON.parse(JSON.stringify(toRaw(form.value)))
  axios.post('/get_tec_globe', info)
    .then((res) => {
      let temp = res.data

      let minValue = temp[0][2];
      for (let i = 0; i < temp.length; i++) {
        if (temp[i][2] < minValue) {
          minValue = temp[i][2];
        }
      }
      minValue = Math.floor(minValue)

      let maxValue = temp[0][2];
      for (let i = 0; i < temp.length; i++) {
        if (temp[i][2] > maxValue) {
          maxValue = temp[i][2];
        }
      }
      maxValue = Math.ceil(maxValue)

      tec.value = temp
      let myChart = echarts.getInstanceByDom(document.getElementById("ECharts_Globe"))
      myChart.setOption(option.value);
      myChart.setOption({ visualMap: { min: minValue, max: maxValue, range: null } });
    })
    .catch((err) => console.log(err))
}

// 重置表单
function reset() {
  ruleFormRef.value.resetFields();
  for (let i = 0; i < 73; i++) {
    for (let j = 0; j < 71; j++) {
      tec.value.push([i, j, 0]);
    }
  }
  let myChart = echarts.getInstanceByDom(document.getElementById("ECharts_Globe"))
  myChart.setOption(option.value);
  myChart.setOption({ visualMap: { min: 0, max: 1, range: null } });
}

// 渲染绘图
function getRenderer() {
  var myChart = echarts.init(document.getElementById('ECharts_Globe'));
  myChart.setOption(option.value);
}

// 生命周期
onMounted(() => {
  getRenderer()
})
</script>




<style scoped>
@media (max-width: 768px) {
  .mylayout {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    --el-font-size-base: 16px;
  }

  .mycharts {
    margin-left: 0px;
    margin-top: 30px;
    display: inline-block;
    width: 300px;
    height: 250px;
  }
}

@media (min-width: 768px) {
  .mylayout {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    --el-font-size-base: 16px;
  }

  .mycharts {
    margin-left: 30px;
    margin-top: 30px;
    display: inline-block;
    width: 600px;
    height: 400px;
  }
}
.el-form {
  padding: 10px;
  display: inline-block;
  border: 1.5px solid black;
}
.el-input-number {
  width: 160px;
  font-size: 16px;
}
.el-input {
  width: 60px;
  font-size: 16px;
}
.el-radio {
  margin: 0px;
}
.el-button {
  border-width: 1.5px;
  width: 108px;
}
</style>